"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const KEY = "SELECTED_THEME";
class SelectedThemeCache {
    constructor() {
        this.tryGet = () => {
            const value = localStorage.getItem(KEY);
            if (value === null) {
                return null;
            }
            return parseInt(value);
        };
        this.set = (value) => {
            localStorage.setItem(KEY, value.toString());
        };
    }
}
const cache = new SelectedThemeCache();
exports.default = cache;
